import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=098ab8ff&"
import script from "./Save.vue?vue&type=script&lang=js&"
export * from "./Save.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports